import { AgGridSvgIconsComponent } from "../../../../../shared/components/ag-grid-svg-icons/ag-grid-svg-icons.component";
import { AgColDefsI, AgGridI } from "../../../../../shared/components/ag-grid/ag-grid.model";
import { CellIconComponent } from "../../../../../shared/components/ag-grid/cell-icon/cell-icon.component";
import { CompanyRendererComponent } from "../../../../../shared/components/ag-grid/company-renderer/company-renderer.component";
import { HeaderIconComponent } from "../../../../../shared/components/ag-grid/header-icon/header-icon.component";
import { PriorityRendererComponent } from "../../../../../shared/components/ag-grid/priority-renderer/priority-renderer.component";
import { RequestNoRendererComponent } from "../../../../../shared/components/ag-grid/request-no-renderer/request-no-renderer.component";
import { ButtonDropdownRendererComponent } from "../../../../../shared/components/button-dropdown-renderer/button-dropdown-renderer.component";
import { AggridHeadername, RequirementHeader } from "../../../../../shared/model/ag-grid-common-constant";
import { GridName } from "../../../../crm/crm.model";
import { SourcingExpandableComponent } from "../../../sourcing-expandable/sourcing-expandable.component";

const ExpandableColumn: AgColDefsI = {
  headerName: "",
  field: "isExpandable",
  editable: false,
  lockPosition: "left",
  headerClass: "width-0",
  lockPinned: true,
  suppressMovable: false,
  resizable:false,
  cellStyle: {
    position: "absolute",
    top: "0px",
    minWidth: "100%",
    left: "0 !important",
    // borderTop: "var(--sitewide_accent_color) solid 1px",
    // borderRight: "var(--sitewide_accent_color) solid 1px",
    // borderBottom: "var(--sitewide_accent_color) solid 1px",
    // borderLeft: "var(--sitewide_scondary_color) solid 3px",
  },
  cellClassRules: {
    "border-0": (params) => !(params?.data?.isExpandable || false),
  },
  
  cellRenderer: SourcingExpandableComponent,
  cellRendererParams: { context: this, isSourcing : true  },
  width: 0,
};

const RequirementsNumberColumn: AgColDefsI = {
    headerName: AggridHeadername.REQ_NO,
    field: "reqNo",
    editable: false,
    sortable: true,
    headerCheckboxSelection: true,
    lockPosition: "left",
    suppressMovable: false,
    lockPinned: true,
    resizable: true,
    cellStyle: {
        paddingLeft: '18px'
    },
    cellClass: "requirement-padding-left-18px",
    checkboxSelection: function (params: any) {
      return !params?.data?.isExpandedRows;
    },
    minWidth: 250,
    flex: 1,
    cellRenderer: RequestNoRendererComponent,
};

const MPNColumn: AgColDefsI = {
    headerName: 'MPN',
    field: "mpn",
    editable: false,
    sortable: true,
    minWidth: 155,
    cellClass: "padding-left-38px ps-4",
    tooltipField: 'mpn',
    cellRenderer: PriorityRendererComponent,
    cellRendererParams: { source: true },
    flex: 1
};

const MFRColumn: AgColDefsI = {
    headerName: 'Mfr',
    field: "mfr",
    editable: false,
    sortable: true,
    minWidth: 143,
    cellClass: "padding-left-38px ps-4",
    tooltipField: 'mfr',
    cellRenderer: (params: any) => params.value === "" ? "<p>&#8212;</p>" : params.value,
    flex: 1
};

const CustomerColumn: AgColDefsI = {
    headerName: 'Customer',
    field: "customer",
    editable: false,
    sortable: true,
    minWidth: 143,
    cellClass: "padding-left-38px ps-4",
    tooltipField: 'customer',
    cellRenderer: (params: any) => params.value ? params.value : "<p>&#8212;</p>",
    flex: 1
};

const ContactColumn: AgColDefsI = {
    headerName: 'Contact',
    field: "contact",
    editable: false,
    sortable: true,
    minWidth: 143,
    cellClass: "padding-left-38px ps-4",
    tooltipField: 'contact',
    cellRenderer: (params: any) => params.value ? params.value : "<p>&#8212;</p>",
    flex: 1
};

const CustomerSTSColumn: AgColDefsI = {
    headerName: 'Customer',
    field: "company",
    editable: false,
    sortable: true,
    minWidth: 143,
    cellClass: "padding-left-38px ps-4",
    tooltipField: 'customer',
    cellRenderer: (params: any) => params.value ? params.value : "<p>&#8212;</p>",
    flex: 1
};

const ContactSTSColumn: AgColDefsI = {
    headerName: 'Contact',
    field: "contactName",
    editable: false,
    sortable: true,
    minWidth: 143,
    cellClass: "padding-left-38px ps-4",
    tooltipField: 'contact',
    cellRenderer: (params: any) => params.value ? params.value : "<p>&#8212;</p>",
    flex: 1
};

const QtyColumn: AgColDefsI = {
    headerName: 'Quantity',
    field: "qty",
    editable: false,
    sortable: true,
    minWidth: 100,
    maxWidth: 100,
    cellClass: "padding-left-38px ps-4",
    tooltipField: 'qty',
    cellRenderer: (params: any) => params.value === "" ? "<p>&#8212;</p>" : params.value,
    flex: 1
};

const DateCodeColumn: AgColDefsI = {
    headerName: 'Date Code',
    field: "dateCode",
    editable: false,
    sortable: true,
    minWidth: 120,
    maxWidth: 120,
    cellClass: "padding-left-38px d-flex justify-content-center align-items-center",
    headerClass: "pe-2 header-col-center",
    tooltipField: 'dateCode',
    cellRenderer: (params: any) => params.value === "" ? "<p>&#8212;</p>" : params.value,
    flex: 1
};

const PriorityColumn: AgColDefsI = {
    headerName: 'Priority',
    field: "priority",
    editable: false,
    sortable: true,
    minWidth: 100,
    maxWidth: 110,
    cellClass: "padding-left-38px ps-0 d-flex justify-content-center align-items-center",
    headerClass: "pe-2 header-col-center",
    tooltipField: 'priority',
    cellRenderer: (params: any) => params.value ? params.value : "<p>&#8212;</p>",
    flex: 1
};

const ApprovedColumn: AgColDefsI = {
    headerName: 'Approved',
    field: "approved",
    editable: false,
    sortable: true,
    minWidth: 100,
    maxWidth: 110,
    cellClass: "padding-left-38px ps-0 d-flex justify-content-center align-items-center",
    headerClass: "pe-2 header-col-center",
    tooltipField: 'approved',
    cellRenderer: (params: any) => params.value === "" ? "<p>&#8212;</p>" : params.value,
    flex: 1
};

const AvailableColumn: AgColDefsI = {
    headerName: 'Available ',
    field: "available",
    editable: false,
    sortable: true,
    minWidth: 100,
    maxWidth: 110,
    cellClass: "padding-left-38px ps-0 d-flex justify-content-center align-items-center",
    headerClass: "pe-2 header-col-center",
    tooltipField: 'available',
    cellRenderer: (params: any) => params.value === "" ? "<p>&#8212;</p>" : params.value,
    flex: 1
};

const PotentialColumn: AgColDefsI = {
    headerName: 'Potential',
    field: "potential",
    editable: false,
    sortable: true,
    minWidth: 100,
    maxWidth: 110,
    cellClass: "padding-left-38px ps-0 d-flex justify-content-center align-item-center",
    headerClass: "pe-2 header-col-center",
    tooltipField: 'potential',
    cellRenderer: (params: any) => params.value === "" ? "<p>&#8212;</p>" : params.value,
    flex: 1
};

const LineStatusColumn: AgColDefsI = {
    headerName: 'Line Status',
    field: "lineStatus",
    editable: false,
    sortable: true,
    minWidth: 180,
    cellClass: "padding-left-38px d-flex align-item-center",
    headerClass: "header-col-center",
    tooltipField: 'lineStatus',
    cellRenderer: ButtonDropdownRendererComponent,
    cellRendererParams: { isReadyStatusDropdown: true },
    flex: 1
};

// Main Sourcing Grid Columns
const SBNoColumn: AgColDefsI = {
    headerName: 'SB No',
    field: "sourcingNo",
    editable: false,
    sortable: true,
    headerCheckboxSelection: true,
    lockPosition: "left",
    suppressMovable: false,
    lockPinned: true,
    resizable: true,
    cellStyle: {
        paddingLeft: '18px',
    },
    checkboxSelection: function (params: any) {
        return !params?.data?.isExpandedRows;
    },
    minWidth: 150,
    flex: 1,
    cellRenderer: CompanyRendererComponent,
};

// Main Sourcing Grid Columns
const RequirementStatusColumn: AgColDefsI = {
    headerName: RequirementHeader.STATUS,
    field: "requirementStatus",
    editable: false,
    sortable: true,
    minWidth: 100,
    cellClass: "padding-left-38px ps-4",
    tooltipField: 'requirementStatus',
    cellRenderer: (params: any) => params.value === "" ? "<p>&#8212;</p>" : params.value,
    flex: 1
};

// Main Sourcing Grid Columns
const StatusColumn: AgColDefsI = {
    headerName: 'Status',
    field: "status",
    editable: false,
    sortable: true,
    minWidth: 100,
    cellClass: "padding-left-38px ps-4 d-flex align-item-center",
    headerClass: "pe-2 header-col-center",
    tooltipField: 'status',
    cellRenderer: (params: any) => params.value === "" ? "<p>&#8212;</p>" : params.value,
    flex: 1
};

const SalespersonColumn: AgColDefsI = {
    headerName: 'Salesperson',
    field: "salesperson",
    editable: false,
    sortable: true,
    minWidth: 100,
    cellClass: "padding-left-38px ps-4 d-flex align-item-center",
    headerClass: "pe-2 header-col-center",
    tooltipField: 'salesperson',
    cellRenderer: (params: any) => params.value === "" ? "<p>&#8212;</p>" : params.value,
    flex: 1
};

const DateCreatedColumn: AgColDefsI = {
    headerName: 'Date Created',
    field: "dateCreated",
    editable: false,
    sortable: true,
    minWidth: 100,
    cellClass: "padding-left-38px ps-4 d-flex align-item-center",
    headerClass: "pe-2 header-col-center",
    tooltipField: 'dateCreated',
    cellRenderer: (params: any) => params.value === "" ? "<p>&#8212;</p>" : params.value,
    flex: 1
};

const PartNoColumn: AgColDefsI = {
    headerName: '# Parts',
    field: "partsCount",
    editable: false,
    sortable: true,
    minWidth: 100,
    cellClass: "padding-left-38px ps-4 d-flex align-item-center",
    headerClass: "pe-2 header-col-center",
    tooltipField: 'partNo',
    cellRenderer: (params: any) => params.value === "" ? "<p>&#8212;</p>" : params.value,
    flex: 1
};

const ReadyToQuoteColumn: AgColDefsI = {
    headerName: 'Ready to Quote',
    field: "readyToQuote",
    editable: false,
    sortable: true,
    minWidth: 100,
    cellClass: "padding-left-38px ps-4 d-flex align-item-center",
    headerClass: "pe-2 header-col-center",
    tooltipField: 'readyToQuote',
    cellRenderer: (params: any) => params.value === "" ? "<p>&#8212;</p>" : params.value,
    flex: 1
};

const NoBidColumn: AgColDefsI = {
    headerName: 'No Bid',
    field: "noBid",
    editable: false,
    sortable: true,
    minWidth: 100,
    cellClass: "padding-left-38px ps-4 d-flex align-item-center",
    headerClass: "pe-2 header-col-center",
    tooltipField: 'noBid',
    cellRenderer: (params: any) => params.value === "" ? "<p>&#8212;</p>" : params.value,
    flex: 1
};


const RequirementNoColumn: AgColDefsI =  {
  headerName: AggridHeadername.REQUIREMENT_NO,
  field: "requirementNo",
  // headerClass: "position-initial",
  // cellClass: "position-initial",
  sortable: true,
  editable: false,
  headerCheckboxSelection: false,
  // lockPosition: "left",
  suppressMovable: false,
  lockPinned: true,
  resizable:false,
//  pinned:'left',
  // cellStyle: {
  //   paddingLeft:'18px',
  // },
  cellClass: "text-primary-color text-decoration-none",
  // checkboxSelection: function (params) {
  //   return !params?.data?.isExpandedRows;
  // },
  tooltipField: 'reqNo',
  minWidth: 200,
  maxWidth:200,
  cellRenderer: RequestNoRendererComponent,
  uniqueName : 'reqNo'

};

const ReqDateColumn: AgColDefsI = {
    headerName: 'Req Date',
    field: "requirementDate",
    editable: false,
    sortable: true,
    minWidth: 100,
    cellClass: "padding-left-38px ps-4",
    tooltipField: 'requirementDate',
    cellRenderer: (params: any) => params.value === "" ? "<p>&#8212;</p>" : params.value,
    flex: 1
};

// sourcing
const ReqNoColumn: AgColDefsI =  {
  headerName: AggridHeadername.REQ_NO,
  field: "reqNo",
  // headerClass: "position-initial",
  // cellClass: "position-initial",
  sortable: true,
  editable: false,
  headerCheckboxSelection: false,
  lockPosition: "left",
  suppressMovable: false,
  lockPinned: true,
  resizable:false,
//  pinned:'left',

  // checkboxSelection: function (params) {
  //   return !params?.data?.isExpandedRows;
  // },
  minWidth: 200,
  maxWidth:200,
  cellRenderer: RequestNoRendererComponent,
  uniqueName : 'reqNo',
  cellRendererParams: { context: this, isSourcing : true  },
};
const ReqSourcingBatchNoColumn: AgColDefsI =  {
  headerName: AggridHeadername.REQ_NO,
  field: "reqNo",
  // headerClass: "position-initial",
  // cellClass: "position-initial",
  sortable: true,
  editable: false,
  headerCheckboxSelection: true,
  lockPosition: "left",
  suppressMovable: false,
  lockPinned: true,
  resizable:false,
//  pinned:'left',
  cellStyle: {
    
 },
  checkboxSelection: function (params) {
    return !params?.data?.isExpandedRows;
  },
  minWidth: 230,
  maxWidth:230,
  cellRenderer: RequestNoRendererComponent,
  uniqueName : 'reqNo',
  cellRendererParams: { context: this },
};

const SourcingExpandableColumn: AgColDefsI = {
 headerName: "",
  field: "isExpandable",
  editable:false,
  lockPosition: "left",
  wrapText: true,
  headerClass: "width-0",
  lockPinned: true,
  suppressMovable: false,
  pinned:'left',
  cellClass:'p-0',
  cellStyle: {
    position: "absolute",
    top: "0",
    pointerEvents: 'none',
    minWidth: "100%",
    left: "0 !important",
    padding: "0 !important"
  },
  cellClassRules: {
    "border-0": (params) => !(params?.data?.isExpandable || false),
  },
  cellRenderer: SourcingExpandableComponent,
  cellRendererParams: { context: this, isSourcing : true  },
  width: 0,
};

const QuantityColumn: AgColDefsI = {
  headerName: AggridHeadername.QUANTITY,
  field: "quantity",
  sortable: true,
  editable: false,
  suppressMovable: true,
  minWidth: 110                                 ,
  cellClass: "padding-left-38px",
  cellRenderer: params => params.value === "" ? "<p>&#8212;</p>" : params.value,
 // flex:1
};
const SourceColumn: AgColDefsI = {
  headerName: AggridHeadername.SOURCE,
  field: "source",
  sortable: true,
  editable: false,
  suppressMovable: true,
  minWidth: 110                                 ,
  cellClass: "padding-left-20px",
  cellRenderer: PriorityRendererComponent,
  cellRendererParams:{source:true}
};
const IconColumn: AgColDefsI = {
  field: "icon",
  headerComponent: HeaderIconComponent,
  suppressMenu: true,
  width: 50,
  minWidth: 50,
  lockPosition: "left",
  lockPinned: true,
  editable: false,

 // pinned:'left',
  cellRenderer: CellIconComponent,
  resizable:false,
  cellRendererParams: { context: this },
  headerComponentParams: { context: this },
  cellClass :"border-0",
  cellStyle: {
    'padding-left':'19px',
  },

};

const SourcingBatchCustomerColumn: AgColDefsI = {
  headerName: 'Customer',
  field: "customer",
  editable: false,
  sortable: true,
  minWidth: 143,
  cellClass: "padding-left-38px",
  tooltipField: 'customer',
  cellRenderer: (params: any) => params.value === "" ? "<p>&#8212;</p>" : params.value,
  flex: 1
};

const SourcingBatchContactColumn: AgColDefsI = {
  headerName: 'Contact',
  field: "contact",
  editable: false,
  sortable: true,
  minWidth: 143,
  cellClass: "padding-left-38px d-flex align-item-center",
  tooltipField: 'contact',
  cellRenderer: (params: any) => params.value === "" ? "<p>&#8212;</p>" : params.value,
  flex: 1
};

const SourcingBatchDateCodeColumn: AgColDefsI = {
  headerName: 'Date Code',
  field: "dateCode",
  editable: false,
  sortable: true,
  minWidth: 100,
  maxWidth: 120,
  cellClass: "padding-left-38px",
  tooltipField: 'dateCode',
  cellRenderer: (params: any) => params.value === "" ? "<p>&#8212;</p>" : params.value,
  flex: 1
};

const SourcingBatchPriorityColumn: AgColDefsI = {
  headerName: 'Priority',
  field: "priority",
  editable: false,
  sortable: true,
  minWidth: 100,
  maxWidth: 130,
  cellClass: "padding-left-38px d-flex align-item-center",
  tooltipField: 'priority',
  cellRenderer: (params: any) => params.value ? params.value : "<p>&#8212;</p>",
  flex: 1
};
const SourcingBatchQuantityColumn: AgColDefsI = {
  headerName: 'Quantity',
  field: "quantity",
  editable: false,
  sortable: true,
  minWidth: 100,
  maxWidth: 110,
  cellClass: "padding-left-38px d-flex align-item-center",
  headerClass: "pe-2 header-col-center",
  tooltipField: 'qty',
  cellRenderer: (params: any) => params.value === "" ? "<p>&#8212;</p>" : params.value,
  flex: 1
};

const SourcingBatchApprovedColumn: AgColDefsI = {
  headerName: 'Approved',
  field: "approved",
  editable: false,
  sortable: true,
  minWidth: 100,
  maxWidth: 110,
  cellClass: "padding-left-38px ps-1 d-flex justify-content-center align-item-center",
  headerClass: "pe-2 ps-4 header-col-center",
  tooltipField: 'approved',
  cellRenderer: (params: any) => params.value === "" ? "<p>&#8212;</p>" : params.value,
  flex: 1
};

const SourcingBatchAvailableColumn: AgColDefsI = {
  headerName: 'Available ',
  field: "available",
  editable: false,
  sortable: true,
  minWidth: 100,
  maxWidth: 110,
  cellClass: "padding-left-38px ps-1 d-flex justify-content-center align-item-center",
  headerClass: "pe-2 ps-4 header-col-center",
  tooltipField: 'available',
  cellRenderer: (params: any) => params.value === "" ? "<p>&#8212;</p>" : params.value,
  flex: 1
};

const SourcingBatchPotentialColumn: AgColDefsI = {
  headerName: 'Potential',
  field: "potential",
  editable: false,
  sortable: true,
  minWidth: 100,
  maxWidth: 110,
  cellClass: "padding-left-38px ps-1 d-flex justify-content-center align-item-center",
  headerClass: "pe-2 ps-4 header-col-center",
  tooltipField: 'potential',
  cellRenderer: (params: any) => params.value === "" ? "<p>&#8212;</p>" : params.value,
  flex: 1
};

const SourcingBatchLineStatusColumn: AgColDefsI = {
  headerName: 'Line Status',
  field: "lineStatus",
  editable: false,
  sortable: true,
  minWidth: 180,
  cellClass: "px-1 d-flex align-item-center",
  headerClass: "header-col-center",
  tooltipField: 'lineStatus',
  cellRenderer: ButtonDropdownRendererComponent,
  cellRendererParams: { isReadyStatusDropdown: true },
  flex: 1
};
export const ColDefsSourcingRequirement: AgColDefsI[] = [
    RequirementsNumberColumn,
    SourcingExpandableColumn,
    IconColumn,
    MPNColumn,
    MFRColumn,
    CustomerColumn,
    ContactColumn,
    QuantityColumn,
    DateCodeColumn,
    PriorityColumn,
    ApprovedColumn,
    AvailableColumn,
    PotentialColumn,
    LineStatusColumn
]

export const ColDefsSourcing: AgColDefsI[] = [
    SBNoColumn,
    StatusColumn,
    SalespersonColumn,
    DateCreatedColumn,
    PartNoColumn,
    ReadyToQuoteColumn,
    NoBidColumn
]

export const ColDefsSourcingBatchOverview: AgColDefsI[] = [
  ReqSourcingBatchNoColumn,
  SourcingExpandableColumn,
  IconColumn,
  MPNColumn,
  MFRColumn,
  SourcingBatchCustomerColumn,
  SourcingBatchContactColumn,
  SourcingBatchQuantityColumn,
  SourcingBatchDateCodeColumn,
  SourcingBatchPriorityColumn,
  SourcingBatchApprovedColumn,
  SourcingBatchAvailableColumn,
  SourcingBatchPotentialColumn,
  SourcingBatchLineStatusColumn
];

export const ColDefsSTSRequirement: AgColDefsI[] = [
  RequirementNoColumn,
  RequirementStatusColumn,
  ReqDateColumn,
  MPNColumn,
  MFRColumn,
  CustomerSTSColumn,
  ContactSTSColumn,
  QtyColumn
];

export const ColDefsSTSSourcing: AgColDefsI[] = [
  SBNoColumn,
  StatusColumn,
  SalespersonColumn,
  DateCreatedColumn,
  PartNoColumn,
  ReadyToQuoteColumn,
  NoBidColumn
];

export const AgGridDataModelSourcingRequirement: AgGridI = {
    colDefs: ColDefsSourcingRequirement,
    rowSelection: "multiple",
    storageName: GridName.SOURCING_REQUIREMENT,
    context : {
      storageName: GridName.SOURCING_REQUIREMENT,
    }
}

export const AgGridDataModelSourcing: AgGridI = {
    colDefs: ColDefsSourcing,
    rowSelection: "multiple",
    storageName: GridName.SOURCING,
    context : {
    storageName :  GridName.SOURCING,
  }
}
export const AgGridDataModelSourcingBatchOverview: AgGridI = {
  colDefs: ColDefsSourcingBatchOverview,
  rowSelection: "multiple",
  columnSettings:true,
  storageName :  GridName.SOURCING_BATCH_OVERVIEW,
  context : {
    storageName :  GridName.SOURCING_BATCH_OVERVIEW,
  }
};
export const AgGridDataModelSTSRequirement: AgGridI = {
  colDefs: ColDefsSTSRequirement,
  rowSelection: "multiple",
  storageName :  GridName.SEND_TO_SOURCING_REQUIREMENT,
};
export const AgGridDataModelSTSSourcing: AgGridI = {
  colDefs: ColDefsSTSSourcing,
  rowSelection: "multiple",
  storageName :  GridName.SEND_TO_SOURCING_SOURCING,
};

const ipadMediaQuery = window.matchMedia("(max-width: 1199.98px)");
function handleMediaChange(e: MediaQueryListEvent | MediaQueryList) {
  if (e.matches) {
    IconColumn.cellStyle = IconColumn.cellStyle || {};
    IconColumn.cellStyle.paddingLeft = '1.5em';
    ReqNoColumn.cellStyle = ReqNoColumn.cellStyle || {};
    ReqNoColumn.cellStyle.paddingLeft = '1.7em';
    ReqSourcingBatchNoColumn.cellStyle = ReqSourcingBatchNoColumn.cellStyle || {};
    ReqSourcingBatchNoColumn.cellStyle.paddingLeft = '1.7em';
    RequirementsNumberColumn.cellStyle = RequirementsNumberColumn.cellStyle || {};
    RequirementsNumberColumn.cellStyle.paddingLeft = '1.7em';
    SourcingExpandableColumn.pinned = 'left';
    SourcingExpandableColumn.cellStyle.left = '0';
  } else {
    IconColumn.pinned = 'left';
    SourcingExpandableColumn.pinned = 'left';
    SourcingExpandableColumn.cellStyle.left = '0';
    ReqNoColumn.pinned = 'left';
    ReqNoColumn.cellStyle = ReqNoColumn.cellStyle || {};
    ReqNoColumn.cellStyle.paddingLeft = '1.4em';
    ReqSourcingBatchNoColumn.pinned = 'left';
    ReqSourcingBatchNoColumn.cellStyle = ReqSourcingBatchNoColumn.cellStyle || {};
    ReqSourcingBatchNoColumn.cellStyle.paddingLeft = '1.4em';
    RequirementsNumberColumn.pinned = 'left';
    RequirementsNumberColumn.cellStyle = RequirementsNumberColumn.cellStyle || {};
    RequirementsNumberColumn.cellStyle.paddingLeft = '1.4em';
  }
}
handleMediaChange(ipadMediaQuery);
ipadMediaQuery.addEventListener('change', handleMediaChange);